export default __webpack_public_path__ + "static/media/tegar.e8d15696.png";